import React, { useState, useContext } from "react";
import {
  TextField,
  Divider,
  InputAdornment,
  IconButton,
  Box,
} from "@mui/material";

import { DataContext } from "../../../context/DataContext";
import { simpleMessage } from "../../../helpers/Helpers";
import { getToken } from "../../../api/Account";
import { Save } from "@mui/icons-material";
import { addSucursalAsync } from "../../../api/Sucursal";

const AddSucursal = ({ setShowModal, localReload, setLocalReload }) => {
  const token = getToken();
  const { setIsLoading, setIsUnautorized } = useContext(DataContext);
  const [description, setDescription] = useState("");

  const saveChangesAsync = async () => {
    if (description.length === 0) {
      simpleMessage("Ingrese una descripción...", "error");
      return;
    }

    setIsLoading(true);
    const result = await addSucursalAsync(token, description);
    if (!result.statusResponse) {
      setIsLoading(false);
      if (result.error === "Unauthorized") {
        setIsUnautorized(true);
        return;
      }
      simpleMessage(result.error, "error");
      return;
    }

    setIsLoading(false);
    simpleMessage("Sucursal Agregada...!", "success");
    setLocalReload(!localReload);
    setShowModal(false);
  };
  return (
    <div>
      <hr />

      <Box sx={{ width: '100%', maxWidth: 450 }}>
        <TextField
          fullWidth
          required
          style={{ marginTop: 20 }}
          onChange={(e) => setDescription(e.target.value.toUpperCase())}
          label={"Sucursal"}
          value={description}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => saveChangesAsync()}>
                  <Save style={{ color: "#1d4ed8" }} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Box>
    </div>
  );
};

export default AddSucursal;
